import { patch, post, httpDelete } from '../../utils/http';

export const addPayRate = (accountId, payrate) => post(`/accounts/${accountId}/payrates/rate`, payrate);

export const updatePayRate = (accountId, payRateId, payrate) =>
  patch(`/accounts/${accountId}/payrates/rate/${payRateId}`, payrate);

export const removePayRate = (accountId, payRateId) => httpDelete(`/accounts/${accountId}/payrates/rate/${payRateId}`);
